import RichText from "@/components/RichText";
import { CoverImage, SmartLink } from "../components/Primitives";
import { CONTAINER, FOOTER_BG, OVERLAY_FOOTER } from "../tokens";

// Pied de page du handoff : bande sombre centrée (min 260px), photo de
// l'atelier en fond (opacité .28) + voile .7, logotype (« AEF » 34px .16em /
// « RETOUCHES » 10px .42em), filet, deux lignes (activité / adresse ·
// téléphone), puis les liens et le copyright.
//
// Couleurs : fond et textes suivent les couleurs de ZONE « Pied de page »
// du Studio (footer-bg / footer-text, voir tailwind.config.js), qui
// retombent sur `ink` / `cream` tant que l'admin n'a rien choisi.
export default function SiteFooter({ props = {}, blocks = [] }) {
  if (String(props.hide_entire_footer) === "true") return null;
  const links = (blocks || [])
    .filter((b) => b.type === "link_item" && b.enabled !== false && b.props?.label)
    .map((b) => ({ id: b.id, label: b.props.label, url: b.props.url || "" }));

  return (
    <footer className="relative min-h-[260px] flex items-center justify-center text-center overflow-hidden" style={FOOTER_BG} data-testid="couture-footer">
      <CoverImage src={props.image_url} opacity={0.28} />
      <div className="absolute inset-0" style={{ background: OVERLAY_FOOTER }} aria-hidden="true" />
      <div className={`${CONTAINER} relative flex justify-center`}>
      <div className="px-6 md:px-8 py-14">
        <div className="font-display font-normal text-[34px] tracking-[0.16em] text-footer-text leading-none">{props.wordmark}</div>
        {props.wordmark_sub && (
          <div className="text-[10px] tracking-[0.42em] uppercase text-footer-text/[0.7] mt-1.5">{props.wordmark_sub}</div>
        )}
        <span className="block w-14 h-px bg-footer-text/40 mx-auto my-[26px]" aria-hidden="true" />
        <div className="text-[11px] tracking-[0.24em] uppercase text-footer-text/[0.78] leading-[2.1]">
          <RichText as="div" html={props.line1} />
          <RichText as="div" html={props.line2} />
        </div>
        <div className="flex items-center justify-center gap-[18px] flex-wrap mt-[26px]">
          {links.map((l) =>
            l.url ? (
              <SmartLink
                key={l.id}
                url={l.url}
                className="inline-flex items-center min-h-[24px] text-[10px] tracking-[0.22em] uppercase text-footer-text/[0.7] hover:text-footer-text border-b border-footer-text/30 pb-[3px] transition-colors"
              >
                {l.label}
              </SmartLink>
            ) : (
              <span key={l.id} className="text-[10px] tracking-[0.22em] uppercase text-footer-text/[0.7]">{l.label}</span>
            )
          )}
          {props.copyright && (
            <RichText as="span" className="text-[10px] tracking-[0.22em] uppercase text-copper" html={props.copyright} />
          )}
        </div>
      </div>
      </div>
    </footer>
  );
}
